import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['history', 'insights']

  declare readonly historyTarget: HTMLElement
  declare readonly insightsTarget: HTMLElement

  manageHistory (): void {
    this.historyTarget.classList.toggle('hidden')
    this.insightsTarget.classList.add('hidden')
  }

  openInsights (event: Event): void {
    this.insightsTarget.classList.remove('hidden')
    this.historyTarget.classList.add('hidden')
  }

  closeInsights (): void {
    this.insightsTarget.classList.add('hidden')
  }
}
